import { useTranslation } from "react-i18next";
import React from "react";
import { Table, Typography } from "antd";
import { MarkDetail } from "../../../../types/markTypes";
import NoDataComponent from "components/Common/NoData";

const { Text } = Typography;

interface Props {
  tableData: any[];
  setSelectedMark: (mark: MarkDetail | null) => void;
  weightedTotalAverage: string | null;
}

const StudentMarksTable: React.FC<Props> = ({ tableData, setSelectedMark, weightedTotalAverage }) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: t("disciplines"),
      dataIndex: "subject",
      key: "subject",
      width: "40%",
      className: 'py-1',
      render: (subject: string, record: { teacher: string; colorCode?: string }) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: record.colorCode || '#ccc', display: 'inline-block' }} />
          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <strong>{subject}</strong>
            <Text type="secondary" style={{ margin: 0 }}>{record.teacher}</Text>
          </span>
        </div>
      ),
    },
    {
      title: t("weight"),
      dataIndex: "weight",
      key: "weight",
      width: "10%",
    },
    {
      title: t("average"),
      dataIndex: "average",
      key: "average",
      width: "20%",
      render: (avg: string | null) => <strong>{avg || "-"}</strong>,
    },
    {
      title: t("evaluations"),
      dataIndex: "marks",
      key: "marks",
      width: "30%",
      render: (marks: MarkDetail[] | null) =>
        marks && marks.length > 0 ? (
          <>
            {marks.map((mark, index) => (
              <span key={index} onClick={() => setSelectedMark(mark)} className="text-primary fw-bold text-decoration-underline me-2" style={{ cursor: "pointer" }}>
                {mark.studentMark ?? "-"}
              </span>
            ))}
          </>
        ) : "-",
    },
  ];

  return (
    <Table
      size="small"
      columns={columns}
      dataSource={tableData}
      pagination={false}
      bordered
      className="table table-striped"
      locale={{ emptyText: <NoDataComponent /> }}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={2}>
            <strong>{t("total_average")}</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={1} colSpan={2} align="center">
            <strong>{weightedTotalAverage ?? "-"}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default StudentMarksTable;
